import { render } from "./grafico.vue?vue&type=template&id=2cb625fa"
import script from "./grafico.vue?vue&type=script&lang=js"
export * from "./grafico.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__